<template>
  <section v-if="items != ''">
    <div class="container">
      <h2 class="pb-2">
        {{ titulo != null ? titulo : this.title != null ? this.title : "" }}
      </h2>
      <div class="row row-cols-2 row-cols-md-4 g-4 text-center" v-if="!items">
        <div class="col" v-for="n in 4" :key="n">
          <div class="card">
            <span class="card-img-top p-3 text-bg-ptn-color-gsj-brand text-white loading-card-second">
            </span>
            <div class="card-body">
              <h3 class="my-0 h6"></h3>
            </div>
          </div> 
        </div>
      </div>
      <div class="row row-cols-2 row-cols-md-4 g-4 text-center">
        <div class="col" v-for="(el, i) in items" :key="i">
          <div class="card position-relative">
            <span class="card-img-top p-3 text-bg-ptn-color-gsj-brand text-white">
              <svg v-if="el.icon && el.icon.includes('ptn')" class="ptn-i-2x" v-bind:class="[iconosGrandes ? 'ptn-i-3x' : '']">
                <use v-bind="{ 'xlink:href': '#' + el.icon }"></use>
              </svg>
              <span v-else class="material-symbols-outlined text-white ptn-i-2x" v-bind:class="[iconosGrandes ? 'ptn-i-3x' : '']">
                {{ el.icon ? el.icon : "description" }}
              </span>
            </span>
            <div class="card-body">
              <h3 class="my-0 h6">
                <a
                  v-if="el.showDropdown"
                  @click.prevent="toggleMenu(i)"
                  href="#"
                  class="text-decoration-none"
                >
                  {{ el.title }}
                </a>
                <a
                  v-else-if="el.action"
                  @click.prevent="handleAction(el.action)"
                  href="#"
                  class="stretched-link text-decoration-none"
                >
                  {{ el.title }}
                </a>
                <a
                  v-else
                  v-bind:href="el.url"
                  v-bind:target="el.target ? el.target : '_self'"
                  class="stretched-link"
                >
                  {{ el.title }}
                </a>
              </h3>
              <div v-if="visibleMenu === i" class="dropdown-menu show">
                <ul class="list-group">
                  <li class="list-group-item" v-for="(link, index) in el.links" :key="index">
                    <a v-bind:href="link.url" v-bind:target="link.target ? link.target : '_blank'">
                      <span><img src="/img/icons/pdf.png" class="pdf" alt=""></span>
                      {{ link.text }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const axios = require("axios");
export default {
  name: "BoxIconGridComponent",
  props: {
    titulo: String,
    subtitulo: String,
    filtros: Object,
    data: Object,
    iconosGrandes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hash: "BIGC",
      items: null,
      title: null,
      desc: null,
      visibleMenu: null, // Estado para controlar la visibilidad del menú desplegable
    };
  },
  methods: {
    toggleMenu(index) {
      this.visibleMenu = this.visibleMenu === index ? null : index;
    },
    handleAction(actionName) {
      this.$emit('action', actionName);
    },
  },
  mounted() {
    if (this.data == null) {
      let params = {};
      if (this.filtros != null && this.filtros != "") {
        params = this.filtros;
      }
      params.tipo = this.hash;
      axios
        .post(process.env.VUE_APP_API_URL, params)
        .then((response) => {
          this.items = response.data ? response.data.items : null;
          this.title = response.data ? response.data.title : null;
          this.desc = response.data ? response.data.desc : null;
          localStorage.setItem(this.hash, JSON.stringify(response));
        })
        .catch((error) => {
          if (!error.response) {
            console.log("Fuera de Línea");
            if (localStorage.getItem(this.hash)) {
              console.log("Cargando elementos de caché para " + this.hash);
              var resp = JSON.parse(localStorage.getItem(this.hash));
              this.items = resp.data ? resp.data.items : null;
              this.title = resp.data ? resp.data.title : null;
              this.desc = resp.data ? resp.data.desc : null;
            }
          }
        });
    } else {
      this.items = this.data;
    }
  },
};
</script>

<style scoped>
section {
  padding-top: 0px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: block;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  min-width: 200px;
}
.pdf{
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
